import { Observable } from 'rxjs';
import { IApiResponse } from '@web/shared-types';
import { AppConfigService } from '../../../app-config.service';
import { inject } from '@angular/core';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { IGetGateway } from '../../gateways';
import { ITariffRelationVia } from '@web/dtos';

export interface IViaRequest {
  serviceAreaId: number;
  maxResults?: number;
  name?: string;
  origin: string;
  destination: string;
}

export class ViasGateway implements IGetGateway<
  IViaRequest,
  IApiResponse<ITariffRelationVia[]>
> {
  private readonly restCallBuilder: RestCallBuilder<ITariffRelationVia[]> =
    new RestCallBuilder<ITariffRelationVia[]>([]);
  private readonly configService: AppConfigService = inject(AppConfigService);

  get(request: IViaRequest): Observable<IApiResponse<ITariffRelationVia[]>> {
    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.tariffUrl + '/relation/vias/',
        {
          serviceAreaId: request.serviceAreaId,
          maxResults: request.maxResults || '',
          origin: request.origin,
          destination: request.destination,
          name: request.name || '',
        }
      )
      .handleMessages()
      .build();
  }
}
